'use client'

import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import IconInfoCard from '@/components/Cards/IconInfoCard'
import FadeInUpBox from '@/components/FadeInOutBox'

interface CardData {
  id?: string | number
  icon: ReactNode
  title: string
  description: string
}

interface IconInfoCardsProps {
  cards: CardData[]
  className?: string
  gridClassName?: string
  cardClassName?: string
  iconSize?: string
  titleClassName?: string
  descriptionClassName?: string
  threshold?: number
  delay?: number
}

const IconInfoCards = ({
  cards,
  className = '',
  gridClassName = '',
  cardClassName = '',
  iconSize,
  titleClassName,
  descriptionClassName,
  threshold,
  delay,
}: IconInfoCardsProps) => {
  return (
    <FadeInUpBox
      className={twMerge(
        'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4',
        gridClassName,
        className,
      )}
      delay={delay}
      threshold={threshold}
    >
      {cards.map((card, index) => (
        <IconInfoCard
          className={cardClassName}
          description={card.description}
          descriptionClassName={descriptionClassName}
          icon={card.icon}
          iconSize={iconSize}
          key={card.id ?? index}
          title={card.title}
          titleClassName={titleClassName}
        />
      ))}
    </FadeInUpBox>
  )
}

export default IconInfoCards
